import { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { database } from "../firebase-config";
import { ref, onValue, increment, set, get } from "firebase/database";

function VisitorCounter() {
  const [pageViews, setPageViews] = useState(0);
  const [uniqueVisitors, setUniqueVisitors] = useState(0);

  useEffect(() => {
    const pageViewsRef = ref(database, 'metrics/pageViews');
    const uniqueVisitorsRef = ref(database, 'metrics/uniqueVisitors');

    // Increment page views
    get(pageViewsRef).then((snapshot) => {
      const currentViews = snapshot.val() || 0;
      set(pageViewsRef, currentViews + 1);
    });    // Check and increment unique visitors
    const visitorKey = 'visitor-flag';
    const isReturningVisitor = localStorage.getItem(visitorKey);

    if (!isReturningVisitor) {
      localStorage.setItem(visitorKey, 'true');
      get(uniqueVisitorsRef).then((snapshot) => {
        const currentVisitors = snapshot.val() || 0;
        set(uniqueVisitorsRef, currentVisitors + 1);
      });
    }

    // Set up real-time listeners for both counters
    onValue(pageViewsRef, (snapshot) => {
      setPageViews(snapshot.val() || 0);
    });

    onValue(uniqueVisitorsRef, (snapshot) => {
      setUniqueVisitors(snapshot.val() || 0);
    });

    // Clean up listeners on component unmount
    return () => {
      // Firebase will automatically clean up the listeners
    };
  }, []);

  return (
    <Container fluid className="visitor-counter">
      <Row>
        <Col>
          <p>Total Views: {pageViews.toLocaleString()}</p>
          <p>Unique Visitors: {uniqueVisitors.toLocaleString()}</p>
        </Col>
      </Row>
    </Container>
  );
}

export default VisitorCounter;
